import { useEffect, useRef, useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'

import { useAuth } from '@/hooks/useAuth'
import Sidebar from './Sidebar'
import Header from './Header'

export default function Layout() {
  const [isMobileOpen, setIsMobileOpen] = useState(false)
  const mainRef = useRef<HTMLElement>(null)
  const { pathname } = useLocation()
  useAuth() // Ensure auth context is available

  useEffect(() => {
    mainRef.current?.scrollTo(0, 0)
  }, [pathname])

  return (
    <>
      {/* The scrim behind the off-canvas navigation, below 48rem (section
          9.7). The deep nav purple, not black, so the drawer reads as the
          product's own chrome sliding over the page. */}
      {isMobileOpen && (
        <div
          className="fixed inset-0 bg-surface-nav-deep/60 z-10 md:hidden"
          onClick={() => setIsMobileOpen(false)}
        />
      )}

      <div className="flex h-screen overflow-hidden">
        {/* Sidebar - dark themed, matches CD layout */}
        <Sidebar isMobileOpen={isMobileOpen} onMobileClose={() => setIsMobileOpen(false)} />

        {/* Main content area */}
        <div className="flex-1 flex flex-col overflow-hidden">
          {/* Header - matches CD pattern */}
          <Header onMobileMenuToggle={() => setIsMobileOpen(true)} />

          {/* Page content.

              bg-surface, not bg-white: this element is the app's canvas, and a
              literal white here is what left dark mode showing a white page
              under a dark rail and header. The token is white in light and the
              deep purple canvas in dark, so the one class covers both.

              It also has to be painted here rather than left to the body. The
              shell is h-screen with overflow-hidden and <main> is the only
              scroll container, so nothing below ever reveals the body's own
              background -- an unpainted <main> would show white regardless of
              what the body is set to.

              scrollbar-gutter:stable permanently reserves the vertical
              scrollbar's width so toggling it (e.g. filtering a list down to
              fewer rows) doesn't change the content width and shift every
              %/fr-based layout -- the "columns/filters jump when filtering"
              bug (OR-363). */}
          <main
            ref={mainRef}
            /*
             * canvas-gradient, on this element and not the body: <main> is the
             * viewport-height scroll container, and the design-system spec
             * (section 5) puts the gradient there so a long page cannot
             * stretch it. The gutter is now the only inset -- there is no
             * content cap, because capping at 90rem left a band of dead canvas
             * down both sides of every wide screen while a fourteen-column
             * table scrolled sideways inside it. p-6 is section 3's 1.5rem
             * page gutter; from lg it opens to 4rem, so the page has a margin
             * rather than running to the edge. Both are on the spacing scale --
             * 4.5rem would have been the exact ask but is not a step on it, and
             * an arbitrary value is what no-arbitrary-values exists to stop, so
             * this is the step above 3rem. It is the one class to dial.
             */
            className="canvas-gradient bg-surface flex-1 overflow-auto p-6 lg:px-16 relative [scrollbar-gutter:stable]"
          >
            <Outlet />
          </main>
        </div>
      </div>

    </>
  )
}
